/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'

export default function useLoginFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const fields = {
        email: {
            name: `${prefix}email`,
            label: formatMessage({
                defaultMessage: 'Email Address',
                id: 'use_login_fields.label.email'
            }),
            placeholder: formatMessage({
                defaultMessage: 'Email Address',
                id: 'use_login_fields.label.email'
            }),
            defaultValue: '',
            type: 'email',
            autoComplete: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please fill out this field.',
                    id: 'use_login_fields.error.required_email'
                }),
                pattern: {
                    value: /^.+@.+\.[a-zA-Z]{2,3}$/,
                    message: formatMessage({
                        defaultMessage: 'Enter a valid email address such as name@email.com.',
                        id: 'use_login_fields.error.pattern_email'
                    })
                }
            },
            inputProps: {
                maxLength: 50
            },
            error: errors?.[`${prefix}email`],
            control,
            variant: 'webFloatingField'
        },
        password: {
            name: `${prefix}password`,
            label: formatMessage({
                defaultMessage: 'Password',
                id: 'use_login_fields.label.password'
            }),
            placeholder: formatMessage({
                defaultMessage: 'Password',
                id: 'use_login_fields.label.password'
            }),
            defaultValue: '',
            type: 'password',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your password.',
                    id: 'use_login_fields.error.required_password'
                })
            },
            inputProps: {
                maxLength: 50
            },
            error: errors?.[`${prefix}password`],
            control,
            variant: 'webFloatingField'
        },
        rememberme: {
            name: `${prefix}rememberme`,
            label: formatMessage({
                defaultMessage: 'Keep me signed in',
                id: 'use_login_fields.label.rememberme'
            }),
            type: 'checkbox',
            defaultValue: false,
            error: errors[`${prefix}rememberme`],
            control,
        },
    }
    return fields
}
